<template>
  <layout-default :hide-footer-mobile="true">
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.7.0/css/all.css"
      integrity="sha384-lZN37f5QGtY3VHgisS14W3ExzMWZxybE1SJSEsQp9S+oqd12jhcu+A56Ebc1zFSJ"
      crossorigin="anonymous"
    />
    <!-- Banner provisional -->
    <div class="banner-pack-container">
      <img
        :src="bannerVentaPack"
        alt="Banner venta pack"
        class="banner-pack-image only-desktop"
      />
      <img
        :src="bannerPackMobile"
        alt="Banner venta pack mobile"
        class="banner-pack-image only-mobile"
      />
    </div>

    <div
      class="statistics-section"
      style="margin-top: 48px; margin-bottom: 48px"
    >
      <div class="pdv-container">
        <div class="statistics-cards">
          <div class="discount-banner">
            <div class="discount-content">
              <div class="discount-badge">100%</div>
              <p class="discount-text">
                <strong>100% de nuestras sedes</strong><br />
                obtuvieron puntajes máximos nacionales
              </p>
            </div>
          </div>

          <div class="discount-banner">
            <div class="discount-content">
              <div class="discount-badge">+700</div>
              <p class="discount-text">
                <strong>Más de 700 puntajes <br />máximos nacionales</strong><br />
                se prepararon con nosotros
              </p>
            </div>
          </div>
          <div class="discount-banner">
            <div class="discount-content">
              <div class="discount-badge">+4800</div>
              <p class="discount-text">
                <strong>Alumnos con puntaje <br />sobre   900 puntos</strong><br />
                se prepararon con nosotros
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="select-container mt-5">
      <div style="margin-bottom: 54px">
        <p class="clases-comenzaron">Las Clases ya comenzaron</p>
        <h3 class="mb-3">{{ isAllianceMode ? 'Busca tu convenio y selecciona tu sede' : 'Selecciona tu sede de preferencia' }}</h3>
        <p v-if="!isAllianceMode">
          Si deseas que tus clases sean en modalidad streaming, selecciona
          nuestra Sede Virtual
        </p>
        <p v-else>
          Ingresa tu RUT para encontrar el convenio asociado a tu cuenta
        </p>
      </div>

      <!-- Alliance RUT lookup section -->
      <div v-if="isAllianceMode" class="alliance-lookup-section">
        <div class="rut-lookup-row">
          <input
            :value="allianceRutInput"
            @input="onRutInput"
            type="text"
            class="select-outlet rut-input"
            placeholder="Ingresa tu RUT (ej: 12.345.678-9)"
            @keydown.enter.prevent="lookupStudentByRut"
            :disabled="allianceLookupLoading"
          />
          <button
            type="button"
            class="btn-lookup"
            @click="lookupStudentByRut"
            :disabled="allianceLookupLoading || !allianceRutInput.trim()"
          >
            {{ allianceLookupLoading ? 'Buscando...' : 'Buscar' }}
          </button>
        </div>
        <p v-if="allianceLookupError" class="lookup-error">{{ allianceLookupError }}</p>
        <div v-if="allianceInfo" class="alliance-info-card">
          <div class="alliance-info-column">
            <h3 class="alliance-info-title">Información del estudiante</h3>
            <div class="alliance-info-item">
              <span class="alliance-info-label">Estudiante</span>
              <p class="alliance-info-value alliance-info-student">{{ allianceStudentInfo.name }}</p>
            </div>
            <div v-if="allianceStudentInfo.rut" class="alliance-info-item">
              <span class="alliance-info-label">RUT estudiante</span>
              <p class="alliance-info-value">{{ allianceStudentInfo.rut }}</p>
            </div>
            <div v-if="allianceStudentInfo.email" class="alliance-info-item">
              <span class="alliance-info-label">Correo estudiante</span>
              <p class="alliance-info-value">{{ allianceStudentInfo.email }}</p>
            </div>
          </div>
          <div class="alliance-info-column">
            <h3 class="alliance-info-title">Información de alianza</h3>
            <div class="alliance-info-item">
              <span class="alliance-info-label">Alianza</span>
              <p class="alliance-info-value alliance-info-name">{{ allianceInfo.name }}</p>
            </div>
            <div v-if="allianceInfo.rut" class="alliance-info-item">
              <span class="alliance-info-label">RUT alianza</span>
              <p class="alliance-info-value">{{ allianceInfo.rut }}</p>
            </div>
            <div v-if="allianceInfo.email" class="alliance-info-item">
              <span class="alliance-info-label">Correo alianza</span>
              <p class="alliance-info-value">{{ allianceInfo.email }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="select-actions">
        <select
          v-model="selectedLocation"
          name="location"
          class="select-outlet"
          :class="{ 'select-disabled': isAllianceMode && !allianceInfo }"
          :disabled="isAllianceMode && !allianceInfo"
          @change="filterPacks"
        >
          <option :value="null" disabled>Seleccionar sede</option>
          <option
            v-for="location in sortedLocationList"
            :key="location.id"
            :value="location"
          >
            {{ location.location }}
          </option>
        </select>
      </div>
      <div class="oferta-completa-wrapper">
        <p class="oferta-completa-texto">
          Si estos packs no te acomodan, revisa nuestra oferta completa aquí
        </p>
        <div class="matriculate-wrapper">
          <a
            href="https://ventaonline.preupdv.cl/"
            target="_blank"
            rel="noopener"
            class="matriculate-link"
          >
            Cotiza aquí
          </a>
          <a
            href="https://ventaonline.preupdv.cl/"
            target="_blank"
            rel="noopener"
            class="arrow-circle"
            aria-label="Ir a preupdv.cl"
          >
            <img :src="topRightIcon" alt="Arrow top right" class="arrow-icon" />
          </a>
        </div>
      </div>
    </div>

    <div class="d-block d-md-none px-3">
      <carousel
        :per-page="1"
        :navigation-enabled="true"
        :pagination-enabled="true"
        :scroll-per-page="true"
        :loop="true"
        :autoplay="true"
        :autoplay-timeout="5000"
        :navigationClickTargetSize="0"
        :spacePadding="0"
        :centerMode="true"
      >
        <slide v-for="pack in paginatedPacks" :key="pack.id">
          <div class="card-program">
            <div
              class="header-card"
              :class="{ 'header-card-egresado': pack.title.toLowerCase().includes('egresado') }"
            >
              <h4 class="title-pack">{{ pack.title }}</h4>
              <a class="sede-pack">
                <strong>{{ formatLocationName(pack.Location.name) }}</strong>
              </a>
            </div>
            <div class="asignatura-bg">
              <h5 class="asignatura">
                Asignaturas
                <span v-if="totalSessionsPack(pack)" class="total-sesiones">
                  {{ totalSessionsPack(pack) }} {{ totalSessionsPack(pack) === 1 ? 'sesión' : 'sesiones' }}
                </span>
              </h5>
            </div>
            <div class="materias-packs">
              <div v-for="detail in pack.PackDetails" :key="detail.courseId">
                <h6 class="materia-detalle mb-0">
                  <img
                    :src="getIcon(pack.modalidad)"
                    class="icon-btn"
                    alt="streaming"
                  />
                  {{ cleanCourseName(detail.Course.name) }}
                </h6>
                <p class="horarios">
                  <template v-for="(schedule, j) in detail.Course.Schedules">
                    {{ schedule.dayOfWeek.substr(0, 3) }}
                    {{ schedule.startTime.replaceAll(":00", "") }} a
                    {{ schedule.endTime.replaceAll(":00", "") }} hs
                    <span v-if="j < detail.Course.Schedules.length - 1" :key="j"
                      >y</span
                    >
                  </template>
                </p>
              </div>
            </div>
            <div class="checkout-card">
              <div class="precio-pack">
                <a class="precio-old">{{ pack.price | moneyFormatter }}</a>
                <h5 class="precio-final">
                  {{ pack.priceOfert | moneyFormatter }}
                </h5>
                <a class="availability">{{ pack.stock }} lugares disponibles</a>
                <div class="precio-pack__buttons">
                  <button type="button" class="btn-pack btn-pack--secondary" @click="addToCart(pack)">
                    Agregar
                  </button>
                  <button type="button" class="btn-pack" @click="gotoSteep2(pack)">
                    Comprar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>

    <div class="container pt-5 d-none d-md-block">
      <div class="row">
        <div
          class="col-12 col-sm-6 col-md-4 col-lg-4 mb-4"
          v-for="pack in paginatedPacks"
          :key="pack.id"
        >
          <div class="card-program">
            <div
              class="header-card"
              :class="{ 'header-card-egresado': pack.title.toLowerCase().includes('egresado') }"
            >
              <h4 class="title-pack">{{ pack.title }}</h4>
              <a class="sede-pack">
                <strong>{{ formatLocationName(pack.Location.name) }}</strong>
              </a>
            </div>

            <div class="asignatura-bg">
              <h5 class="asignatura">
                Asignaturas
                <span v-if="totalSessionsPack(pack)" class="total-sesiones">
                  {{ totalSessionsPack(pack) }} {{ totalSessionsPack(pack) === 1 ? 'sesión' : 'sesiones' }}
                </span>
              </h5>
            </div>
            <div class="materias-packs">
              <div v-for="detail in pack.PackDetails" :key="detail.courseId">
                <h6 class="materia-detalle mb-0">
                  <img
                    :src="getIcon(pack.modalidad)"
                    class="icon-btn"
                    alt="streaming"
                  />
                  {{ cleanCourseName(detail.Course.name) }}
                </h6>

                <p class="horarios">
                  <template v-for="(schedule, j) in detail.Course.Schedules">
                    {{ schedule.dayOfWeek.substr(0, 3) }}
                    {{ schedule.startTime.replaceAll(":00", "") }} a
                    {{ schedule.endTime.replaceAll(":00", "") }} hs
                    <span
                      v-if="j < detail.Course.Schedules.length - 1"
                      :key="j"
                    >
                      y
                    </span>
                  </template>
                </p>
              </div>
            </div>
            <!-- Agregar campo descripcion del curso que este centrado -->
            <p class="descripcion-curso text-center">
              {{ pack.description }}
            </p>
            <div class="precio-line"></div>
            <div class="checkout-card">
              <div class="precio-pack">
                <a class="precio-old">
                  {{ pack.price | moneyFormatter }}
                </a>
                <h5 class="precio-final">
                  {{ pack.priceOfert | moneyFormatter }}
                </h5>
                <a class="availability">
                  {{ pack.stock }} lugares disponibles
                </a>
                <div class="precio-pack__buttons">
                  <!-- TODO: Habilitar el botón de agregar al carro de compras cuando requiera el carro de compras -->
                  <button type="button" class="btn-pack btn-pack--secondary" @click="addToCart(pack)">
                    Agregar
                  </button>
                  <button type="button" class="btn-pack" @click="gotoSteep2(pack)">
                    Comprar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination justify-content-center">
        <button
          v-for="page in totalPagesArray"
          :key="page"
          @click="changePage(page)"
          :class="{ active: page === currentPage }"
        >
          {{ page }}
        </button>
      </div>
    </div>

    <div class="recuadro-wrapper">
      <a
        href="https://ventaonline.preupdv.cl/"
        class="recuadro"
        style="text-decoration: none"
      >
        <h2
          style="
            color: #000000;
            font-size: 30px;
            font-family: 'Poppins', sans-serif;
            font-weight: 700 !important;
            line-height: 1.2;
          "
        >
          Revisa nuestra oferta completa de cursos

        </h2>
      </a>
    </div>
    <div class="matriculate-wrapper">
      <a
        href="https://ventaonline.preupdv.cl/"
        target="_blank"
        rel="noopener"
        class="matriculate-link"
      >
        Cotiza aquí
      </a>
      <a
        href="https://ventaonline.preupdv.cl/"
        target="_blank"
        rel="noopener"
        class="arrow-circle"
        aria-label="Ir a preupdv.cl"
      >
        <img :src="topRightIcon" alt="Arrow top right" class="arrow-icon" />
      </a>
    </div>
    <!-- <div class="page-not-found">
            <div class="container h-100">
                <div class="main-content">
                    <img src="/images/404.png" alt="">
                    <h3>Oh oh… algo salío mal</h3>
                    <p>Lo sentimos, no pudimos encontrar la página que necesitabas</p>

                    <div class="row justify-content-center">
                        <div class="col-md-3 col-8">
                            <router-link :to="{name: 'Landing'}" class="btn-pdv-primary w-100">VOLVER AL INICIO</router-link>
                        </div>
                    </div>


                </div>
            </div>
        </div>  -->

    <InfoHelpGrid />
    <!-- TODO: Habilitar el componente de FloatingOutletCart cuando requiera el carro de compras -->
    <floating-outlet-cart
      :cart-count="outletCartCount"
      :cart-items="outletCartItems"
      :show-back-to-packs="true"
      @cart-updated="onCartUpdated"
    />
  </layout-default>
</template>

<script>
import LayoutDefault from "@/layouts/Default";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { Carousel, Slide } from "vue-carousel";
import bannerPack from "@/assets/banner-pack.png";
import bannerVentaPack from "@/assets/banner-venta-pack.png";
import bannerPackMobile from "@/assets/banner-pack-mobile.png";
import topRightIcon from "@/assets/icons/top-right.png";
import InfoHelpGrid from "@/components/featured/InfoHelpGrid.vue";
import FloatingOutletCart from "@/components/outlet/FloatingOutletCart.vue";
import outletCartService from "@/services/outletCartService";
import bannersService from "@/services/bannersService";

Vue.use(VueSweetalert2);

global.jQuery = require("jquery");
const $ = global.jQuery;
window.$ = $;

export default {
  data() {
    return {
      packs: [],
      filteredPacks: [],
      locations: [],
      locationsList: [],
      selectedLocation: null,
      onlineSalesLink: "https://ventaonline.preupdv.cl",
      currentPage: 1,
      itemsPerPage: 15,
      bannerPack: bannerPack,
      defaultBannerVentaPack: bannerVentaPack,
      defaultBannerPackMobile: bannerPackMobile,
      cmsVentaPackDesktop: "",
      cmsVentaPackMobile: "",
      topRightIcon: topRightIcon,
      InfoHelpGrid: InfoHelpGrid,
      outletCartCount: 0,
      outletCartVersion: 0,
      allianceRutInput: "",
      allianceLookupLoading: false,
      allianceLookupError: "",
      allianceInfo: null,
      allianceStudentInfo: null,
      allianceId: null,
    };
  },
  computed: {
    bannerVentaPack() {
      return this.cmsVentaPackDesktop || this.defaultBannerVentaPack;
    },
    bannerPackMobile() {
      return this.cmsVentaPackMobile || this.defaultBannerPackMobile;
    },
    outletCartItems() {
      this.outletCartVersion;
      return outletCartService.getCart();
    },
    totalPages() {
      return Math.ceil(this.filteredPacks.length / this.itemsPerPage);
    },
    paginatedPacks() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredPacks.slice(startIndex, endIndex);
    },

    isAllianceMode() {
      return this.$route && this.$route.meta && this.$route.meta.isAllianceMode === true;
    },

    sortedLocationList() {
      return this.locationsList
        .map((loc) => {
          let nombre = loc.location.trim();

          // Reemplazamos "Norte " solo en los casos específicos
          if (nombre === "Norte Calama") nombre = "Calama";
          if (nombre === "Norte La Serena") nombre = "La Serena";
          if (nombre === "Norte Antofagasta") nombre = "Antofagasta";

          return { ...loc, location: nombre }; // Retornamos el objeto con el nombre modificado
        })
        .filter((loc) => {
          // Filtrar "Alameda" de las opciones
          const locationName = loc.location || "";
          return !locationName.toLowerCase().includes("alameda");
        })
        .filter((loc) => loc.location.toLowerCase() !== "pdv online") // Eliminamos PDV Online
        .sort((a, b) => a.location.localeCompare(b.location));
    },

    totalPagesArray() {
      return Array.from({ length: this.totalPages }, (_, i) => i + 1);
    },
  },

  //TODO: Habilitar el componente de FloatingOutletCart cuando requiera el carro de compras
  components: {
    LayoutDefault,
    Carousel,
    Slide,
    InfoHelpGrid,
    FloatingOutletCart,
  },
  created() {
    this.loadCampaignBanners();
    this.outletCartCount = outletCartService.getCount();
    if (!this.isAllianceMode) {
      this.loadCachedData();
      this.getLocations();
      this.getPacks();
    }
    const zoomScript = document.createElement("script");
    zoomScript.src = "https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js";
    zoomScript.setAttribute("data-apikey", "G4nAX1GiTf6ib-GJAcV4Qw");
    zoomScript.setAttribute("data-env", "us01");
    zoomScript.async = true;
    document.body.appendChild(zoomScript);
  },

  beforeDestroy() {
    const script = document.querySelector(
      'script[src="https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js"]',
    );
    if (script) {
      script.remove(); // Elimina el script al salir de la página
    }
  },

  methods: {
    async loadCampaignBanners() {
      try {
        const banners = await bannersService.getCampaignBanners();
        if (banners.ventaPack) {
          this.cmsVentaPackDesktop = banners.ventaPack.desktop || "";
          this.cmsVentaPackMobile = banners.ventaPack.mobile || "";
        }
      } catch (error) {
        console.error("Error loading campaign banners:", error);
      }
    },
    formatRut(value) {
      let cleaned = value.replace(/[^0-9kK]/g, '');
      if (cleaned.length === 0) return '';
      let body = cleaned.slice(0, -1);
      let dv = cleaned.slice(-1).toUpperCase();
      if (body.length === 0) return dv;
      let formatted = '';
      while (body.length > 3) {
        formatted = '.' + body.slice(-3) + formatted;
        body = body.slice(0, -3);
      }
      formatted = body + formatted;
      return formatted + '-' + dv;
    },
    onRutInput(e) {
      const raw = e.target.value;
      const formatted = this.formatRut(raw);
      this.allianceRutInput = formatted;
      this.$nextTick(() => {
        e.target.value = formatted;
      });
    },
    loadCachedData() {
      try {
        const cachedData = localStorage.getItem('outletStep1Data');
        if (cachedData) {
          const data = JSON.parse(cachedData);
          if (data.selectedLocation) {
            this.selectedLocation = data.selectedLocation;
          }
          if (data.currentPage) {
            this.currentPage = data.currentPage;
          }
        }
      } catch (error) {
        console.error('Error loading cached data:', error);
      }
    },
    saveCachedData() {
      try {
        const dataToCache = {
          selectedLocation: this.selectedLocation,
          currentPage: this.currentPage,
        };
        localStorage.setItem('outletStep1Data', JSON.stringify(dataToCache));
      } catch (error) {
        console.error('Error saving cached data:', error);
      }
    },
    async getLocations() {
      try {
        const { data } = await this.Axios.get("/locations?pdvX=true");
        const formatedData = data.map((element) => ({
          ...element,
          name: element.name
            .replace(/^Preuniversitario\s*/, "")
            .replace(/^Pre\s*/, ""),
        }));
        this.locationsList = formatedData.map((loc) => ({
          location: loc.name,
          id: loc.id,
        }));
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Ha ocurrido un error al cargar las sedes",
          icon: "error",
        });
      }
    },
    formatLocationName(name) {
      return name
        .replace(/^Preuniversitario\s*/, "Sede ")
        .replace(/^Pre\s*/, "Sede ");
    },

    cleanCourseName(name) {
      let newName = name
        .replace(/\s\d{3}$/, "") // Elimina códigos de 3 dígitos al final
        .replace(/\b(Tercero|Tarde|Egresado)\b/g, "") // Elimina palabras específicas
        .trim(); // Limpia espacios extra

      // Reemplazos específicos
      if (newName === "Lenguaje") return "Competencia Lectora";
      if (newName === "Matemática") return "Competencia Matemática M1";
      if (newName === "Matemática Electivo") return "Competencia Matemática M2";

      return newName;
    },

    async getPacks() {
      try {
        const params = { _t: Date.now() };
        if (this.isAllianceMode && this.allianceId) {
          params.allianceId = this.allianceId;
        }
        const { data } = await this.Axios.get("/dashadmin/activepacks", {
          params,
        });
        this.packs = data;
        this.filteredPacks = data;
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Ha ocurrido un error al cargar los paquetes",
          icon: "error",
        });
      }
    },

    async lookupStudentByRut() {
      if (!this.allianceRutInput.trim()) return;
      this.allianceLookupLoading = true;
      this.allianceLookupError = "";
      this.allianceInfo = null;
      this.allianceStudentInfo = null;
      this.allianceId = null;
      this.selectedLocation = null;
      this.packs = [];
      this.filteredPacks = [];
      this.locationsList = [];
      try {
        const rutToSend = this.allianceRutInput.replace(/[^0-9kK]/g, '');
        const { data } = await this.Axios.get("/students-alliances/lookup", {
          params: { rut: rutToSend },
        });
        this.allianceStudentInfo = { name: data.name, rut: data.rut };
        this.allianceInfo = data.alliance;
        this.allianceId = data.alliance.id;
        await this.getPacks();
        this.extractLocationsFromPacks();
      } catch (error) {
        const msg = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Error al buscar el estudiante";
        this.allianceLookupError = msg;
      } finally {
        this.allianceLookupLoading = false;
      }
    },

    extractLocationsFromPacks() {
      const locMap = {};
      this.packs.forEach((pack) => {
        if (pack.Location && pack.Location.id && !locMap[pack.Location.id]) {
          locMap[pack.Location.id] = {
            id: pack.Location.id,
            location: pack.Location.name
              .replace(/^Preuniversitario\s*/, "")
              .replace(/^Pre\s*/, ""),
          };
        }
      });
      this.locationsList = Object.values(locMap);
    },
    getUniqueLocations() {
      const uniqueLocations = [];
      this.packs.forEach((pack) => {
        pack.PackDetails.forEach((detail) => {
          const locationName = detail.Location.name;
          if (!uniqueLocations.includes(locationName)) {
            uniqueLocations.push(locationName);
          }
        });
      });
      return uniqueLocations;
    },

    totalSessionsPack(pack) {
      if (!pack.PackDetails || !pack.PackDetails.length) return 0;
      return pack.PackDetails.reduce((sum, d) => sum + (d.sessions || 0), 0);
    },

    getIcon(modalidad) {
      switch (modalidad) {
        case "Presencial":
          return "/images/featured/frame.svg";
        case "Streaming":
          return "/images/featured/monitor-recorder.svg";
        default:
          return "/images/featured/online.svg";
      }
    },
    getLocation(pack) {
      if (pack.PackDetails.length > 0) {
        let value = "";
        pack.PackDetails.forEach((detail) => {
          if (value != detail.Location.name) {
            this.locationList.push(detail.Location.name);
          }
          value = detail.Location.name;
        });
      }
    },
    async addToCart(pack) {
      try {
        const { data: fullPack } = await this.Axios.get(
          `/dashadmin/fullpacks/${pack.id}`
        );
        outletCartService.addPack(fullPack);
      } catch {
        outletCartService.addPack(pack);
      }
      this.outletCartCount = outletCartService.getCount();
      this.outletCartVersion++;
      this.$swal.fire({
        position: "top-end",
        icon: "success",
        title: "Pack agregado al carro",
        showConfirmButton: false,
        timer: 1500,
        toast: true,
      });
    },
    onCartUpdated() {
      this.outletCartCount = outletCartService.getCount();
      this.outletCartVersion++;
    },
    async gotoSteep2(pack) {
      try {
        const { data: fullPack } = await this.Axios.get(
          `/dashadmin/fullpacks/${pack.id}`
        );
        outletCartService.addPack(fullPack);
      } catch {
        outletCartService.addPack(pack);
      }
      this.$router.push({ name: "Outlet2", query: { packId: pack.id } });
    },

    data() {
      return {
        packs: [],
        locationsList: [],
        selectedLocation: "",
      };
    },

    async filterPacks() {
      await this.getPacks();
      if (!this.selectedLocation) {
        this.filteredPacks = this.packs;
      } else {
        this.filteredPacks = this.packs.filter((pack) => {
          return pack.locationId === this.selectedLocation.id;
        });
      }
      this.currentPage = 1;
      this.saveCachedData();
    },

    changePage(page) {
      this.currentPage = page;
      this.saveCachedData();
    },
    onLocationSelected({ id }) {
      this.selectedLocation = id;
      this.saveCachedData();
    },
  },
  watch: {
    selectedLocation() {
      this.saveCachedData();
    },
  },
};
</script>

<style lang="scss" scoped>
.alliance-lookup-section {
  width: 100%;
  max-width: 554px;
  margin: 0 auto 24px auto;
}

.rut-lookup-row {
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
}

.btn-lookup {
  height: 48px;
  padding: 0 28px;
  border-radius: 100px;
  border: 2px solid #3691d8;
  background-color: #3691d8;
  color: white;
  font-size: 16px;
  font-family: "ubunturegular", Arial, sans-serif;
  cursor: pointer;
  white-space: nowrap;
  box-sizing: border-box;

  &:hover {
    background-color: #2a7bc0;
    border-color: #2a7bc0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 400px;
  }
}

.lookup-error {
  color: #e53935;
  font-size: 14px;
  margin-top: 8px;
  text-align: center;
}

.alliance-info-card {
  margin-top: 16px;
  padding: 24px;
  border: 2px solid #a0a1a6;
  border-radius: 12px;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  gap: 40px;
  text-align: left;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
  }
}

.alliance-info-column {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.alliance-info-title {
  color: #000;
  font-family: 'Poppins-Bold', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  margin: 0 0 20px 0;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 16px;
  }
}

.alliance-info-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
}

.alliance-info-label {
  color: #666;
  font-family: 'Poppins-Regular', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 4px;
}

.alliance-info-value {
  color: #000;
  font-family: 'Poppins-Medium', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  margin: 0;
  word-break: break-word;
}

.alliance-info-name {
  color: #000;
}

.alliance-info-student {
  color: #000;
}

.d-block.d-md-none {
  position: relative;
  padding: 0 40px;
}

.banner-descuento-wrapper {
  position: relative;
  width: 100%;
}

.carousel {
  width: 100%;
  position: relative;
}

.VueCarousel-wrapper {
  overflow: visible !important;
  padding: 0 20px;
}

.VueCarousel-slide {
  display: flex;
  justify-content: center;
}

.VueCarousel-navigation-button {
  position: absolute !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  border-radius: 50%;
  width: 50px !important;
  height: 50px !important;
  top: 50% !important;
  transform: translateY(-50%);
  z-index: 10;
  color: white !important;
  font-size: 24px !important;
  padding: 0 !important;
  margin: 0 !important;
  cursor: pointer;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.VueCarousel-navigation-button.VueCarousel-navigation-prev {
  left: 0 !important;
}

.VueCarousel-navigation-button.VueCarousel-navigation-next {
  right: 0 !important;
}

.VueCarousel-navigation-button::before {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  font-size: 24px;
  color: white;
}

.VueCarousel-navigation-button.VueCarousel-navigation-prev::before {
  content: "\f104";
}

.VueCarousel-navigation-button.VueCarousel-navigation-next::before {
  content: "\f105";
}

.banner-pack-container {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    margin: -10px 0 0 0;
  }
}

.banner-pack-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }

  @media (min-width: 769px) {
    width: 100%;
    height: auto;
  }
}

.only-mobile {
  display: block;

  @media (min-width: 769px) {
    display: none !important;
  }
}

.only-desktop {
  display: none;

  @media (min-width: 769px) {
    display: block !important;
  }
}

.prime-title {
  font-family: "Poppins", sans-serif;
  font-weight: 800;
  font-size: 68px;
  line-height: 120%;
  letter-spacing: 0px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 40px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    font-size: 54px;
  }
}

.banner-text-overlay {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  z-index: 10;
  padding: 5% 0 0;

  @media (max-width: 768px) {
    padding: 5% 0 0;
  }
}

.banner-text-overlay-left {
  left: 0;
  align-items: flex-start;
  padding-left: 8%;
  max-width: 38%;

  .venta-pack-title,
  .admision-badge {
    display: block;
  }

  @media (max-width: 480px) {
    padding-left: 5%;
    max-width: 45%;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    padding-left: 6%;
    max-width: 42%;
  }

  @media (min-width: 1200px) {
    padding-left: 10%;
    max-width: 35%;
  }
}

.banner-text-overlay-right {
  right: 0;
  left: auto;
  align-items: flex-start;
  padding-right: 18%;
  padding-left: 0;
  text-align: left;

  .matricula-title,
  .matricula-subtitle {
    display: block;
  }

  @media (max-width: 768px) {
    padding-right: 35%;
    padding-left: 6%;
    left: 0;
    right: auto;
    top: auto;
    bottom: 15%;
  }

  @media (min-width: 1200px) {
    padding-right: 20%;
  }
}

.br-mobile {
  display: none;

  @media (max-width: 1024px) {
    display: block;
  }
}

.venta-pack-title {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: clamp(32px, 3.35vw, 64px);
  line-height: 120%;
  letter-spacing: 0px;
  margin: 0 0 0.5rem 0;
  color: #ffffff;

  @media (max-width: 480px) {
    font-size: 18px;
    margin: 0 0 0.25rem 0;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    font-size: 22px;
    margin: 0 0 0.25rem 0;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    font-size: clamp(22px, 2.9vw, 30px);
  }
}

.admision-badge {
  background-color: #ffd200;
  color: #1b1b1d;
  padding: clamp(10px, 0.85vw, 16px) clamp(16px, 1.7vw, 32px);
  display: inline-block;
  margin: 0 0 0.5rem 0;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: clamp(22px, 2.2vw, 42px);
  line-height: 1.2;
  width: fit-content;
  text-align: center;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 6px 14px;
    font-size: 22px;
    margin: 0.5rem 0 0.25rem 0;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    font-size: clamp(18px, 2vw, 26px);
    padding: clamp(8px, 0.8vw, 14px) clamp(12px, 1.4vw, 20px);
  }
}

.matricula-title {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 68px;
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin: 0 0 0.25rem 0;
  color: #ffffff;

  @media (max-width: 768px) {
    font-size: 36px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    font-size: 54px;
  }
}

.matricula-subtitle {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 36px;
  line-height: 1.3;
  margin: 0;
  color: #ffd200;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    font-size: 30px;
  }
}

.select-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
  max-width: fit-content;
}

.banner-home-title {
  margin-bottom: 0;
  color: $colorTerciario;
  font-family: "Poppins-ExtraBold", sans-serif;
  z-index: 10;

  @media (max-width: 768px) {
    margin: 24px 0 24px 0;
    font-size: 30px;
    line-height: 28px;
    text-align: center;
  }
  @media (min-width: 769px) {
    margin-top: 12px;
    font-size: 48px;
    line-height: 58px;
    text-align: center;
  }
}
.banner-home-title2 {
  margin-bottom: 0;
  margin-top: 12px;
  color: $colorTerciario;
  font-family: "Poppins-Medium", sans-serif;
  font-size: 36px !important;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 35px;
  }
  @media (min-width: 769px) {
    margin-top: 17px;
    font-size: 20px;
    line-height: 35px;
  }
}

.banner-home-title3 {
  margin-bottom: 0;
  margin-top: 17px;
  color: $colorTerciario;
  font-family: "Poppins-Medium", sans-serif;
  font-size: 20px !important;
  text-align: center;
}

.img-header {
  width: 456px;

  @media (max-width: 768px) {
    width: 312px;
    height: 202px;
  }
}

.recuadro {
  position: relative;
  display: block;
  background-color: transparent;
  color: #1b1b1d !important;
  font-weight: 700;
  font-size: 25px;
  text-align: center;
  margin: 0;
  width: 70vw;
  max-width: 800px;
  padding: 12px 20px;
  box-sizing: border-box;
  border-radius: 50px;
}

.recuadro h2 {
  color: #000000;
  font-size: 30px;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  line-height: 1;
  margin: 0;
  padding: 0 10px;
}

.recuadro h2 span {
  font-weight: 600;
  font-size: 1.4em;
  font-family: "Arial Black", "Arial Bold", Gadget, sans-serif;
}

/* Responsivo */
@media (min-width: 768px) {
  .recuadro {
    font-size: 2.25rem;
    padding: 12px 20px;
    min-width: 400px;
    max-width: 800px;
    border-radius: 50px;
  }

  .recuadro h2 {
    font-size: 30px;
  }
}

@media (max-width: 767px) {
  .recuadro {
    padding: 10px 15px;
    width: 80vw;
    border-radius: 50px;
  }

  .recuadro h2 {
    font-size: 24px;
  }
}

.recuadro-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 2rem auto;
  width: fit-content;
  max-width: 90vw;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 16px;
  }
}

.matriculate-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 1rem auto;
  width: fit-content;
  max-width: 90vw;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 16px;
  }
}

.matriculate-link {
  background-color: #ffd202;
  color: #000000;
  font-weight: bold;
  font-size: 16px;
  padding: 16px 32px;
  border-radius: 9999px;
  text-decoration: none;
  display: inline-block;
  white-space: nowrap;

  &:hover {
    text-decoration: none;
    color: #000000;
  }

  @media (min-width: 768px) {
    font-size: 18px;
    padding: 18px 36px;
  }
}

.arrow-circle {
  width: 55px;
  height: 55px;
  background-color: #ffd202;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-decoration: none;

  .arrow-icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }

  @media (min-width: 768px) {
    width: 60px;
    height: 60px;

    .arrow-icon {
      width: 22px;
      height: 22px;
    }
  }

  @media (max-width: 767px) {
    width: 60px;
    height: 60px;

    .arrow-icon {
      width: 22px;
      height: 22px;
    }
  }
}

.select-filtro {
  width: 250px;
  height: 38px;
  border: 2px solid lightgray;
  border-radius: 30px 30px 30px 30px;
}
.select-outlet {
  min-width: 240px;
  max-width: 300px;
}

.seleccion-sede {
  font-size: 12px;
  color: #8a8c93;
  margin-left: 18px;
}
.banner-descuento img {
  width: 100%;
  height: auto;
  display: block;
}

.info-recomendador1 {
  .fondo {
    background-color: $neutral05;
  }

  .perent-columns {
    display: flex;
    @media (max-width: 768px) {
      flex-direction: column;
      padding: 48px 24px;
    }
    @media (min-width: 769px) {
      flex-direction: row;
      padding: 40px 76px 64px 76px;
      gap: 50px;
    }

    .column-info {
      display: flex;
      flex-direction: column;
      @media (max-width: 768px) {
        width: 100%;
      }
      @media (min-width: 769px) {
        width: 622px;
      }

      .titulo {
        color: $neutralBlack;
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 27px;
          line-height: 37px;
          margin-bottom: 32px;
        }
        @media (min-width: 769px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 40px;
          line-height: 50px;
          margin-bottom: 24px;
        }
      }
      .links {
        display: flex;
        flex-direction: column;
        @media (min-width: 769px) {
          margin-bottom: 40px;
        }

        .links-items {
          display: flex;
          justify-content: space-between;
          padding: 16px 0;

          @media (max-width: 768px) {
            width: 100%;
          }
          @media (min-width: 769px) {
            width: 400px;
          }

          .links-items-text {
            img {
              margin-right: 12px;
            }
            span {
              color: $neutralBlack;
              font-family: "Poppins-Medium", sans-serif;
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
      .texto {
        color: $neutralBlack;
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 27px;
          line-height: 37px;
          margin-bottom: 32px;
        }
        @media (min-width: 769px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 24px;
        }
      }
      .botones {
        display: flex;
        flex-wrap: wrap;

        @media (max-width: 768px) {
          flex-direction: column;
          gap: 16px;
        }
        @media (min-width: 769px) {
          flex-direction: row;
          gap: 16px;
        }
      }
    }
    .column-ilustracion {
      @media (max-width: 768px) {
        width: 100%;
        margin: 48px 0 36px 0;
      }
      @media (min-width: 769px) {
        flex: 1;
      }
    }
  }
}

.container {
  padding: 0 15px;

  @media (max-width: 768px) {
    padding: 0 12px;
  }
}

.select-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  margin: 3rem auto;
  text-align: center;

  .select-actions {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;

    .select-outlet {
      width: 554px;
      max-width: 554px;

      @media (max-width: 768px) {
        width: 90%;
        max-width: 400px;
      }
    }

    .btn-outlet-filtro {
      white-space: nowrap;
    }
  }
}

.oferta-completa-wrapper {
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;

  .oferta-completa-texto {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    color: #333;
    line-height: 1.4;

    @media (min-width: 768px) {
      font-size: 18px;
    }
  }
}

.card-program {
  flex-direction: column;
  justify-content: space-between;
  height: 580px;

  display: flex;
  border: 1px solid #a0a1a6;
  border-radius: 8px 24px 8px 8px;
  margin: 0 auto 32px auto;

  @media (max-width: 768px) {
    width: 83%;
    flex-direction: column;
    align-items: stretch;
    padding: 0;
    overflow: hidden;
    box-sizing: border-box;
  }
  @media (min-width: 769px) {
    flex-direction: column;
    padding: 10px;
  }
  .header-card {
    min-height: 100px;
    background-color: #e1eff9;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    margin: -10px -10px 0 -10px;
    padding: 1rem calc(1rem + 10px);
    border-radius: 8px 24px 0 0;

    &.header-card-egresado {
      background-color: #fde68a
    }

    @media (max-width: 768px) {
      align-items: center;
      text-align: center;
      margin: 0;
      padding: 1rem;
      border-radius: 8px 24px 0 0;
      width: 100%;
      box-sizing: border-box;
      min-width: 0;
    }
    @media (min-width: 769px) {
      align-items: flex-start;
      text-align: left;
    }
  }

  .title-pack {
    font-size: 18px;
    color: #1b1b1d;
    font-family: "Poppins-Bold";
    margin: 0 0 8px 0;

    @media (min-width: 769px) {
      font-size: 20px;
    }
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  .asignatura-bg {
    padding: 16px, 24px, 16px, 24px;
    background-size: cover;
    gap: 10px;
    margin: 0px -10px 0px -10px;

    @media (max-width: 768px) {
      width: 100%;
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
  }

  .asignatura {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    color: #3b3c3f;
    font-family: "Poppins-Medium", sans-serif;
    font-size: 16px;
    line-height: 24px;
    padding-left: 20px;

    @media (max-width: 768px) {
      width: 100%;
      height: auto;
      padding: 12px 1rem;
      box-sizing: border-box;
    }
  }

  .total-sesiones {
    font-weight: 500;
    white-space: nowrap;
  }

  .materias-packs {
    flex-grow: 1;
    overflow-y: auto;
    box-sizing: border-box;

    @media (max-width: 768px) {
      padding: 15px 1rem 30px 1rem;
      height: auto;
      min-height: 200px;
      width: 100%;
      max-height: 280px;
      margin: 0;
      box-sizing: border-box;
    }

    > div {
      width: 100%;
      box-sizing: border-box;

      @media (max-width: 768px) {
        padding: 0;
        margin-bottom: 12px;
      }
    }
    @media (min-width: 769px) {
      padding: 15px 10px 80px 10px;
      margin: 0px -10px 0px -10px;
      height: 400px;
    }
    @media (max-width: 576px) {
      max-height: 250px;
    }

    @media (min-width: 577px) and (max-width: 768px) {
      max-height: 300px;
    }

    @media (min-width: 769px) {
      max-height: 280px;
    }
  }

  .horarios {
    font-family: Poppins, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0px;
    color: #4e4f55;
  }

  .materia-detalle {
    font-family: Poppins, sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0px;
    color: #1b1b1d;
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
      padding: 0;
      margin: 0;
    }

    .icon-btn {
      flex-shrink: 0;
      width: 20px;
      height: 20px;

      @media (max-width: 768px) {
        width: 18px;
        height: 18px;
      }
    }
  }

  .checkout-card {
    display: flex;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
      padding: 0 0 1.5rem 0;
      margin: 0;
    }
  }

  .precio-line {
    height: 1px;
    background-color: #a0a1a6;
    margin: 0 4px;
  }

  .precio-old {
    text-decoration: line-through;
    font-size: 10px;
    color: #8a8c93;
    position: relative;
    padding-top: 8px;
  }
  .precio-final {
    font-weight: bolder;
    color: black;
  }
  .availability {
    font-size: 12px;
    display: block;
    margin-bottom: 12px;
  }

  .precio-pack {
    padding: 0 1rem;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
      padding: 0 1rem 1.5rem 1rem;
      width: 100%;
      box-sizing: border-box;
      margin: 0;
    }

    .precio-pack__buttons {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 10px;
      margin-top: 12px;
    }

    .btn-pack {
      flex: 1;
      min-width: 140px;
      height: 46px;
      padding: 12px 24px;
      border-radius: 100px;
      border-width: 3px;
      border: 3px solid #3691d8;
      background-color: #3691d8;
      color: white;
      font-size: 15px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      cursor: pointer;
      box-sizing: border-box;
      opacity: 1;
      text-align: center;
      @media (max-width: 768px) {
        min-width: 120px;
        height: 46px;
      }
      &.btn-pack--secondary {
        background-color: transparent;
        color: #3691d8;
        border: 2px solid #3691d8;
      }
      &.btn-pack--secondary:hover {
        background-color: rgba(54, 145, 216, 0.08);
      }
    }
  }

  .btn-comprar {
    padding-top: 18px;
    padding-left: 30px;

    @media (min-width: 769px) {
      text-align: right;
    }

    .btn-pack {
      width: 174px;
      height: 46px;
      padding-top: 12px;
      padding-right: 24px;
      padding-bottom: 12px;
      padding-left: 24px;
      border-radius: 100px;
      border-width: 3px;
      border: 3px solid #3691d8;
      background-color: #3691d8;
      color: white;
      font-size: 15px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      cursor: pointer;
      box-sizing: border-box;
      opacity: 1;
      text-align: center;
      @media (max-width: 768px) {
        width: 174px;
        height: 46px;
        margin: 0;
      }
      @media (min-width: 769px) {
        margin: 0;
      }
    }
  }
}

.page-nro {
  border: 1px solid grey;
  border-radius: 8px;
  padding: 8px;
}
.pagination {
  margin-top: 20px;
}

.pagination button {
  background-color: transparent;
  color: black;
  border: 2px solid grey;
  border-radius: 4px;
  padding: 5px 10px;
  margin-right: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.pagination button:hover {
  background-color: transparent;
}

.pagination button.active {
  background-color: transparent;
  font-weight: bold;
}

.pagination button:disabled {
  background-color: transparent;
  color: #6c757d;
  cursor: not-allowed;
}

.page-nro {
  margin: 0 15px;
  font-size: 16px;
  font-weight: bold;
}

.select-outlet {
  width: 554px;
  height: 48px;
  padding-top: 12px;
  padding-right: 24px;
  padding-bottom: 12px;
  padding-left: 24px;
  border-radius: 100px;
  border-width: 2px;
  border: 2px solid #a0a1a6;
  font-size: 16px;
  line-height: 18px;
  font-family: "ubunturegular", Arial, sans-serif;
  color: #a0a1a6;
  background: transparent;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg fill="%23A0A1A6" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 20px;
  cursor: pointer;
  box-sizing: border-box;
  outline: none;
  opacity: 1;

  &:focus {
    border-color: #a0a1a6;
    outline: none;
  }

  option {
    padding: 8px;
  }

  @media (max-width: 768px) {
    width: 90%;
    max-width: 400px;
  }

  &.rut-input{
    background-image: none;
    cursor: unset;
    flex: 1;
    width: auto;
    max-width: none;

    &::placeholder {
      color: rgba(#a0a1a6, 0.5);
    }
  }

  &.select-disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}
.sede-pack {
  color: #333;
  font-family: "Poppins-Medium";
  font-size: 14px;

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (min-width: 769px) {
    font-size: 15px;
  }
}

.porque-pdv-section {
  padding: 3rem 1rem;
  background-color: #fff;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
  }

  .section-title {
    font-size: 2.25rem;
    font-weight: 800;
    color: #1b1b1d;
    font-family: "Poppins-Bold", sans-serif;
    margin-bottom: 2rem;

    span {
      background: linear-gradient(to top, #ffb347 40%, transparent 40%);
      display: inline-block;
      padding: 0 8px;
    }

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  .cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 2rem;

    .razon-card {
      background-color: #f1f1f2;
      border: 2px solid #000;
      border-radius: 10px 40px 10px 10px;
      padding: 1rem 1.5rem;
      font-weight: 600;
      font-family: "Poppins-Medium", sans-serif;
      max-width: 260px;
      width: 100%;
      text-align: center;
    }
  }

  .ver-mas-wrapper {
    margin-top: 1rem;

    .btn-ver-mas {
      border: 2px solid #000;
      border-radius: 100px;
      padding: 0.5rem 1.5rem;
      background-color: transparent;
      font-size: 1rem;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      color: black;

      &:hover {
        background-color: #000;
        color: #fff;
      }
    }
  }
}

.poppins-regular {
  font-family: "Poppins", sans-serif !important;
  font-weight: 400 !important;
  font-style: normal !important;
}

.poppins-bold {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700 !important;
  font-style: normal !important;
}
</style>

<style scoped lang="scss">
.page-not-found {
  text-align: center;
  padding-top: 50px;
  height: 80vh;
  .main-content {
    position: relative;
    top: 50%;
    transform: translateY(-50%);

    img {
      width: 300px;
      @include media-breakpoint-down(sm) {
        width: 80%;
      }
    }
    h3 {
      font-size: 38px;
      @include alternative-medium-regular;
      margin-bottom: 10px;

      @include media-breakpoint-down(sm) {
        font-size: 24px;
        line-height: 28px;
      }
    }
    p {
      font-size: 20px;
      line-height: 24px;
      @include alternative-light-regular;
      margin-bottom: 24px;

      @include media-breakpoint-down(sm) {
        line-height: 22px;
        font-size: 18px;
      }
    }
  }
}

/* Statistics Section */
.statistics-section {
  .pdv-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;

    @media (max-width: 768px) {
      padding: 0 12px;
    }
  }

  .statistics-cards {
    display: flex;
    gap: 80px;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      gap: 40px;
    }
  }
}

/* Discount Banner */
.discount-banner {
  position: relative;
  z-index: 10;
  flex-shrink: 0;
}

.discount-content {
  width: 300px;
  background-color: white;
  border-radius: 12px;
  border: 2px solid #fbbf24;
  padding: 1.2rem 1.2rem;
  position: relative;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.discount-content::before {
  content: "";
  position: absolute;
  width: 239px;
  height: 57px;
  background-color: #ffea8a;
  top: -16px;
  left: 79px;
  z-index: -1;
}

.discount-content::after {
  content: "";
  position: absolute;
  width: 30px;
  height: 30px;
  background-color: #ffe25c;
  top: 91px;
  left: -13px;
  z-index: -1;
}

.discount-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #1a1a1a;
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 12px;
  font-weight: 800;
  font-size: 1.25rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  letter-spacing: -0.02em;
  min-width: 48px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.discount-badge.highlight {
  background-color: #1a1a1a;
  color: white;
}

.discount-text {
  color: #4a4a4a;
  font-weight: 400;
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.discount-text strong {
  font-weight: 700;
  color: #1a1a1a;
}
</style>
